import { useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { ArrowUpRight, Menu, MessageCircle, X } from "lucide-react";
import { logo, whatsapp } from "@/data/site";

export default function Header() {
  const [menu, setMenu] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();
  const onBlogs = location.pathname.startsWith("/blogs");

  const go = id => {
    setMenu(false);
    const scroll = () => document.getElementById(id)?.scrollIntoView({ behavior: "smooth" });
    if (location.pathname !== "/") {
      navigate("/");
      setTimeout(scroll, 400);
    } else scroll();
  };
  const goBlogs = () => { setMenu(false); navigate("/blogs"); };

  return (
    <header className="site-nav">
      <div className="nav-inner">
        <button className="brand" data-testid="nav-home-link" onClick={() => go("home")}><img src={logo} alt="ADVOKIT" /></button>
        <nav className={menu ? "nav-links open" : "nav-links"}>
          <button data-testid="nav-home-link-mobile" onClick={() => go("home")}>Home</button>
          <button data-testid="nav-courses-link" onClick={() => go("courses")}>Courses</button>
          <button data-testid="nav-blogs-link" className={onBlogs ? "active" : ""} onClick={goBlogs}>Blogs</button>
          <button data-testid="nav-resources-link" onClick={() => go("resources")}>Resources</button>
          <a className="career-club-link" data-testid="nav-career-club-link" href="https://lexintern.co.in/" target="_blank" rel="noreferrer">Join Lexintern Career Club <ArrowUpRight size={13} /></a>
        </nav>
        <div className="nav-actions">
          <a className="text-link" data-testid="cta-call-chat-button" href={whatsapp} target="_blank" rel="noreferrer">Call / Chat <MessageCircle size={16} /></a>
          <button className="nav-cta" data-testid="cta-explore-courses-button" onClick={() => go("courses")}>Explore courses <ArrowUpRight size={16} /></button>
        </div>
        <button className="menu-toggle" data-testid="mobile-menu-button" onClick={() => setMenu(!menu)}>{menu ? <X /> : <Menu />}</button>
      </div>
    </header>
  );
}
